import http from "../../api/apiClient";
import type { BankAccount, BankAccountFormValues, EntityId, Family, FamilyPayload, ParentOption, SchoolYear } from "./types";

export const fetchFamilies = async (): Promise<Family[]> => {
  const { data } = await http.get<Family[]>("/families");
  return Array.isArray(data) ? data : [];
};

export const fetchFamily = async (id: EntityId): Promise<Family> => {
  const { data } = await http.get<Family>(`/families/${id}`);
  return data;
};

export const createFamily = async (payload: FamilyPayload): Promise<Family> => {
  const { data } = await http.post<Family>("/families", payload);
  return data;
};

export const updateFamily = async (id: EntityId, payload: FamilyPayload): Promise<Family> => {
  const { data } = await http.put<Family>(`/families/${id}`, payload);
  return data;
};

export const fetchParentOptions = async (): Promise<ParentOption[]> => {
  const { data } = await http.get<ParentOption[]>("/parents");
  return Array.isArray(data) ? data : [];
};

export const fetchSchoolYears = async (): Promise<SchoolYear[]> => {
  const { data } = await http.get<SchoolYear[]>("/years");
  return Array.isArray(data) ? data : [];
};

export const approveBankAccount = async (bankAccountId: EntityId, adminUuid: EntityId | null | undefined): Promise<void> => {
  await http.post(`/bank-accounts/${bankAccountId}/approve`, null, {
    params: { adminUuid },
  });
};

export const createBankAccount = async (
  parentUuid: EntityId,
  values: BankAccountFormValues
): Promise<BankAccount> => {
  const { data } = await http.post<BankAccount>("/bank-accounts", {
    parentUuid,
    iban: values.iban,
    accountHolderName: values.accountHolderName,
  });
  return data;
};
